<template>
  <Modal
    :model-value="props?.isOpen.value"
    :close="props?.options?.backgroundClose === false ? () => '' : hide"
    @after-leave="afterLeave"
  >
    <div class="modal-gallery" @click.self="hide">
      <span class="modal-gallery-close" @click="hide">
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          class="modal-gallery-close__icon"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M3.60002 2.00879L21.991 20.3998L20.4 21.9908L2.00903 3.59978L3.60002 2.00879Z"
            fill="white"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M21.991 3.59978L3.60002 21.9908L2.00903 20.3998L20.4 2.00879L21.991 3.59978Z"
            fill="white"
          />
        </svg>
      </span>
      <div
        :class="{ 'modal-gallery__wide': props?.options?.width }"
        :style="{ 'max-width': props?.options?.width }"
      >
        <slot />
      </div>
    </div>
  </Modal>
</template>

<script lang="ts" setup>
import { Ref } from 'vue';
import useModal from '@use/useModal/useModal';

const modal = useModal();

const props = defineProps<{
  isOpen: Ref;
  options?: {
    width?: string;
    backgroundClose?: boolean;
    empty?: boolean;
    padding?: boolean;
  };
  afterLeave: () => void;
}>();

const hide = () => {
  modal.hide();
};
</script>

<style lang="scss" scoped>
.modal-gallery {
  display: flex;
  align-items: center;
  justify-content: center;
  &__wide {
    width: 100%;
  }
}
.modal-gallery-close {
  position: absolute;
  top: 16px;
  right: 16px;
  cursor: pointer;
  z-index: 2;
  @include point-md {
    top: 24px;
    right: 24px;
  }
  @include point-lg {
    top: 40px;
    right: 80px;
  }
  &__icon {
    width: 18px;
    height: 18px;
    @include point-md {
      width: 24px;
      height: 24px;
    }
  }
}
</style>
